<script lang="ts">
  import Tabs from "../../components/Tab/Tabs.svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import DossierDetailFragment from "./DossierDetailFragment.svelte";
  import DossierActivitiesFragment from "./DossierActivitiesFragment.svelte";

  export let oid: number;

  $: isNew = oid == 0;

  enum DossierPage {
    General = 1,
    Activities,
  }

  let currentTab: DossierPage = DossierPage.General;

  // onMount(() => initDetail(oid));
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == DossierPage.General}
      on:click={(_) => {
        currentTab = DossierPage.General;
      }}
    />
    {#if isNew == false}
      <Tab
        label="Attività"
        active={currentTab == DossierPage.Activities}
        on:click={(_) => {
          currentTab = DossierPage.Activities;
        }}
      />
    {/if}
  </Tabs>

  {#if currentTab == DossierPage.General}
    <DossierDetailFragment {oid} />
  {/if}
  {#if currentTab == DossierPage.Activities}
    <DossierActivitiesFragment {oid} />
  {/if}
</MainLayout>
